import * as actions from './../Action-type/Index';
import { makeId } from '../Services/service'
// import { fil } from 'date-fns/locale';
// import { ItemGroup } from 'rc-menu';

const initialState = {
  graphicsAcucumulated: [],
  graphicsWorkSpace: [],
  filter: {
    ep: [],
    country: [],
    genero: [],
    docType: [],
    comuna: [],
    barrio: [],

    estadoCivil: [],
    escolaridad: [],
    afiliacion: [],
    tipoVivienda: [],
    stationary: [],
    razonOcupacion: [],
    actividadProductiva: [],
    sisben: [],
    finanType: [],

    activity: [],
    galeryType: [],
    awarded: [],

    typeOper: [],
    liderOper: [],
    spaceWasOper: [],

    typeVisAdv: [],

    autorityInc: [],

    fenomeno: [],

    // poligono: [],
    // year: [],
    year: [new Date().getFullYear()],
    month: [],
    semester: [],
    day: '',
    range: [],
    socketPath: makeId()
  },
  coords: [],
  filterArray: [
    // { id: 1, value: 'ESPACIO PÚBLICO', name: "ep" },
    { id: new Date().getFullYear(), value: new Date().getFullYear().toString(), name: "year" }
  ],
  noneAction: false,
  signal: false,
  signalPoint: false,
  addPointGroup: {},
  openAddedPoint: false,
  addedPoint: null,
  pointsToShow: []
}

const filterModel = {
  ep: [],
  estadoCivil: [],
  actividadProductiva: [],
  tipoVivienda: [],
  razonOcupacion: [],

  capturas: [],
  fenomeno: [],
  descripcionConducta: [],
  spoaCaracterizacion: [],
  comuna: [],
  barrio: [],
  claseSitio: [],
  jornada: [],
  modalidad: [],
  conductaEspecial: [],
  medioArma: [],
  zona: [],
  genero: [],
  etareo: [],
  causa: [],
  grupoVulnerable: [],
  medioConocimiento: [],
  captsCircunstancia: [],
  secadArma: [],
  secadCategoria: [],
  secadCategoriaConvivencia: [],
  secadClasificacionCierre: [],
  secadDescripcionCodigo: [],
  secadDescripcionAtendido: [],
  secadItem: [],
  secadModalidad: [],
  secadTipoCaso: [],
  secadTipoPedido: [],
  fuenteDato: [],
  poligono: [],
  year: [],
  month: [],
  semester: [],
  day: '',
  range: [],
  socketPath: initialState.filter.socketPath
}

function getFilter(filterArray) {
  let filter = JSON.parse(JSON.stringify(filterModel))
  for (let i = 0; i < filterArray.length; i++) {
    if (filterArray[i].name === 'range') {
      filter[filterArray[i].name].push(filterArray[i].value)
    } else if (filterArray[i].name === 'day') {
      filter.day = filterArray[i].value
    } else {
      filter[filterArray[i].name].push(filterArray[i].id)
    }
  }
  return filter
}

function getFilterArray(clickData, filterData) {
  let filter = [...filterData]
  if (JSON.stringify(filter).includes(JSON.stringify(clickData))) {
    let resp = filter.filter(item => {
      if (JSON.stringify(item) === JSON.stringify(clickData))
        return false
      return true
    }).map(item => item)
    return resp
  }
  filter.push(clickData)
  return filter
}

function dashReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SIGNAL_UPDATE:
      return {
        ...state,
        signal: !state.signal,
      };
    case actions.POINTS_TO_SHOW:
      return {
        ...state,
        pointsToShow: action.payload.points,
      };
    case actions.SIGNAL_POINT:
      if (!state.signalPoint)
        return {
          ...state,
          signalPoint: true,
          addPointGroup: action.payload,
          openAddedPoint: true
        }
      return {
        ...state,
        signalPoint: false,
      };
    case actions.ADDED_POINT:
      if (action.payload.status)
        return {
          ...state,
          addedPoint: action.payload.addedPoint,
          openAddedPoint: false
        }
      return {
        ...state,
        addedPoint: null,
        openAddedPoint: false
      };
    case actions.LOGIN_ACCOUNT:
      var session = localStorage.getItem("session");
      if (session !== null || session === '') {
        const dataSesion = JSON.parse(session)
        if (dataSesion.users.perfil !== 'ASOMURA') {
          let id
          const filterName = 'mpio'
          switch (dataSesion.users.perfil) {
            case 'Apartadó': id = 1; break
            case 'Arboletes': id = 10; break
            case 'Carepa': id = 2; break
            case 'Chigorodó': id = 3; break
            case 'Murindó': id = 9; break
            case 'Mutatá': id = 4; break
            case 'Necoclí': id = 5; break
            case 'San Juan de Urabá': id = 8; break
            case 'San Pedro de Urabá': id = 7; break
            case 'Turbo': id = 6; break
            default: return { ...initialState }
          }
          const filterArray = getFilterArray({ id, value: dataSesion.users.perfil, name: filterName }, initialState.filterArray)
          const filter = getFilter(filterArray)
          return { ...initialState, filter, filterArray };
        }
        return { ...initialState };
      }
      return { ...initialState }
    case actions.SELECT_FILTER_FENOMENE:
      if (!state.noneAction) {
        let filterArray = getFilterArray({ ...action.payload }, state.filterArray)
        let filter = getFilter(filterArray)
        return { ...state, filter, filterArray, noneAction: true };
      }
      return { ...state, noneAction: false }
    case actions.SELECT_FILTER_CHARACTERISTIC:
      let filterArray = getFilterArray({ ...action.payload }, state.filterArray)
      let filter = getFilter(filterArray)
      return { ...state, filter, filterArray };
    case actions.ACTION_NAME: return { ...state };
    case actions.DELETE_DATA:
      return {
        ...state,
        graphicsWorkSpace: [],
        graphicsAcucumulated: []
      };
    case actions.OPEN_FILE:
      return {
        ...state,
        graphicsWorkSpace: action.payload.graphicsWorkSpace,
        graphicsAcucumulated: action.payload.graphicsAcucumulated
      };
    case actions.CHANGE_CLASS_TEXTS:
      console.log(action.payload);
      let inGraphicsCCT = [];
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        if (state.graphicsWorkSpace[i].id === action.payload.id) {
          inGraphicsCCT.push({
            ...state.graphicsWorkSpace[i],
            classes: action.payload.classes
          });
        } else {
          inGraphicsCCT.push(state.graphicsWorkSpace[i]);
        }
      }
      return {
        ...state,
        graphicsWorkSpace: inGraphicsCCT,
      };
    case actions.SELECT_SHIELD:
      let nowSS = new Date();
      let inGraphicsSS = [];
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        inGraphicsSS.push(state.graphicsWorkSpace[i]);
      }
      let respSS = {
        id: nowSS.getTime(),
        graphic: action.payload.graphic,
        type: action.payload.type,
        x: 0,
        y: 0,
        width: action.payload.width,
        height: action.payload.height,
        width0: action.payload.width,
        height0: action.payload.height,
      }
      inGraphicsSS.push(respSS);
      return {
        ...state,
        graphicsWorkSpace: inGraphicsSS
      };
    case actions.EDIT_TEXT:
      let inGraphicsET = [];
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        if (state.graphicsWorkSpace[i].id !== action.payload.id) {
          inGraphicsET.push(state.graphicsWorkSpace[i]);
        } else {
          let respET = {
            ...state.graphicsWorkSpace[i],
            text: action.payload.text,
          }
          inGraphicsET.push(respET);
        }
      }
      return {
        ...state,
        graphicsWorkSpace: inGraphicsET
      };
    case actions.MORE_TEXT:
      let nowMT = new Date();
      let inGraphics = [];
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        inGraphics.push(state.graphicsWorkSpace[i]);
      }
      let respMT = {
        id: nowMT.getTime(),
        text: '',
        type: 'text',
        x: 0,
        y: 0,
        width: 100,
        height: 50,
        classes: 'budy-calibri-12 text-active',
      }
      inGraphics.push(respMT);
      return {
        ...state,
        graphicsWorkSpace: inGraphics
      };
    case actions.DELETE:
      let graphicsAccDel = [];
      let graphicsSelDel = [];
      for (let i = 0; i < state.graphicsAcucumulated.length; i++) {
        if (state.graphicsAcucumulated[i].id !== action.payload.id) {
          graphicsAccDel.push(state.graphicsAcucumulated[i]);
        }
      }
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        if (state.graphicsWorkSpace[i].id !== action.payload.id) {
          graphicsSelDel.push(state.graphicsWorkSpace[i]);
        }
      }
      return {
        ...state,
        graphicsAcucumulated: graphicsAccDel,
        graphicsWorkSpace: graphicsSelDel,
      };
    case actions.CREATE_COPY:
      let graphicsAccCC = [];
      let graphicsSelCC = [];
      for (let i = 0; i < state.graphicsAcucumulated.length; i++) {
        graphicsAccCC.push(state.graphicsAcucumulated[i]);
        if (state.graphicsAcucumulated[i].id === action.payload.id) {
          let now = new Date();
          graphicsAccCC.push({
            ...state.graphicsAcucumulated[i],
            id: now.getTime(),
            x: 0,
            y: 0,
            width: state.graphicsAcucumulated[i].width0,
            height: state.graphicsAcucumulated[i].height0,
          });
        }
      }
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        graphicsSelCC.push(state.graphicsWorkSpace[i]);
        if (state.graphicsWorkSpace[i].id === action.payload.id) {
          let now = new Date();
          graphicsAccCC.push({
            ...state.graphicsWorkSpace[i],
            id: now.getTime(),
            x: 0,
            y: 0,
            width: state.graphicsWorkSpace[i].width0,
            height: state.graphicsWorkSpace[i].height0,
          });
        }
      }
      return {
        ...state,
        graphicsAcucumulated: graphicsAccCC,
        graphicsWorkSpace: graphicsSelCC,
      };
    case actions.MORE_GRAPHICS:
      let now = new Date();
      let resp = {
        id: now.getTime(),
        graphic: action.payload.graphic,
        type: action.payload.type,
        x: 0,
        y: 0,
        width: action.payload.width,
        height: action.payload.height,
        width0: action.payload.width,
        height0: action.payload.height,
      }
      state.graphicsAcucumulated.push(resp);
      return { ...state };
    case actions.LESS_GRAPHICS:
      let graphics = []
      for (let i = 0; i < state.graphicsAcucumulated.length; i++) {
        if (state.graphicsAcucumulated[i].id !== action.payload.id) {
          graphics.push(state.graphicsAcucumulated[i]);
        }
      }
      return {
        ...state,
        graphicsAcucumulated: graphics,
      };
    case actions.ACCOMULATE_INFORM:
      let graphicsAcc = [];
      let graphicsSel = [];
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        graphicsSel.push(state.graphicsWorkSpace[i]);
      }
      for (let i = 0; i < state.graphicsAcucumulated.length; i++) {
        if (state.graphicsAcucumulated[i].id !== action.payload.id) {
          graphicsAcc.push(state.graphicsAcucumulated[i]);
        } else {
          graphicsSel.push(state.graphicsAcucumulated[i]);
        }
      }
      return {
        ...state,
        graphicsAcucumulated: graphicsAcc,
        graphicsWorkSpace: graphicsSel,
      };
    case actions.BACK_GRAPHIC:
      let graphicsAccu = [];
      let graphicsSelu = [];
      for (let i = 0; i < state.graphicsAcucumulated.length; i++) {
        graphicsAccu.push(state.graphicsAcucumulated[i]);
      }
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        if (state.graphicsWorkSpace[i].id !== action.payload.id) {
          graphicsSelu.push(state.graphicsWorkSpace[i]);
        } else {
          graphicsAccu.push({
            ...state.graphicsWorkSpace[i],
            x: 0,
            y: 0,
            width: state.graphicsWorkSpace[i].width0,
            height: state.graphicsWorkSpace[i].height0,
          });
        }
      }
      return {
        ...state,
        graphicsAcucumulated: graphicsAccu,
        graphicsWorkSpace: graphicsSelu,
      };
    case actions.RESIZE_ELEMENT:
      let graphicsRE = [];
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        if (state.graphicsWorkSpace[i].id === action.payload.id) {
          graphicsRE.push({
            ...state.graphicsWorkSpace[i],
            width: action.payload.width,
            height: action.payload.height
          });
        } else {
          graphicsRE.push(state.graphicsWorkSpace[i]);
        }
      }
      return {
        ...state,
        graphicsWorkSpace: graphicsRE,
      };
    case actions.MOVE_ELEMENT:
      console.log('en move', action.payload);
      let graphicsME = [];
      for (let i = 0; i < state.graphicsWorkSpace.length; i++) {
        if (state.graphicsWorkSpace[i].id === action.payload.id) {
          graphicsME.push({
            ...state.graphicsWorkSpace[i],
            x: action.payload.x,
            y: action.payload.y
          });
        } else {
          graphicsME.push(state.graphicsWorkSpace[i]);
        }
      }
      return {
        ...state,
        graphicsWorkSpace: graphicsME,
      };
    default: return { ...state };
  }
}

export default dashReducer;
